import {Pipe, PipeTransform} from '@angular/core';
import {User} from '../class/central/user';

@Pipe({
  name: 'userFormatter'
})
export class UserFormatterPipe implements PipeTransform {

  transform(value: User, ...args: any[]): any {
    if (!value) {
      return 'Utente non impostato'
    }

    const name = value.name;
    const surname = value.surname;
    return (name != null ? name : '') + ' ' + (surname != null ? surname : '');
  }

}
